import ResourceManagementRoutes from './routes'

export default {
  // name version 必须为字面常量
  name: 'resource-management',
  title: 'identityServer管理',
  version: '0.1.21',
  flag: 2, // flag 1-常规模块 2-host管理菜单 4-租户管理员菜单
  description: '客户端身份',
  routes: ResourceManagementRoutes, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: [
      'ApiResourceApi',
      'ClaimTypeApi',
      'ApiScopeApi',
      'ClientApi',
      'IdentityResourceApi',
      'PermissionsApi',
    ],
  },
  /**
   * init: async (store, router, config) {}
   * 异步初始化函数原型
   */
}
